import React, { useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import { useEffect, useState, useRef } from "react";
import axiosInstance from "../helpers/axiosInstance";
import View from '../images/view.svg';
import Edit from '../images/edit.png';
import Delete from "../images/delete.svg";
import { FaFilter } from 'react-icons/fa';
import { IoClose } from "react-icons/io5";
import { useLoading } from '../context/LoadingContext';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import './trip.css';

const Trip = () => {

    const [trips, setTrips] = useState([]);
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [page, setPage] = useState(1);
    const [inputPage, setInputPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [showVendorFilter, setShowVendorFilter] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState("");
    const [vendorOptions, setVendorOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [showBulkModal, setShowBulkModal] = useState(false);
    const [vendorSearch, setVendorSearch] = useState("");


    const [formData, setFormData] = useState({
        number: "",
        location_id: "",
        bay_type_id: "",
        shop_id: ""
    });
    const { updateLoading } = useLoading();
    const navigate = useNavigate();

    // fetchTrips 
    const fetchTrips = useCallback(async () => {
        updateLoading(true);
        setIsLoading(true);

        try {
            const response = await axiosInstance.get("/api/trip/get-trips", {
                params: {
                    page,
                    limit: 10, // actual pagination limit
                    search: searchTerm || "",
                    vendor: selectedVendor || "", // send selected vendor to backend
                },
            });

            const fetchedTrips = response.data.data || [];
            const { totalPages } = response.data.pagination;

            setTrips(fetchedTrips);
            if (fetchedTrips.length === 0) {
                setTotalPages(1);
                setPage(1);
                setInputPage(0); // show 0 of 1
            } else {
                setTotalPages(totalPages);
                // Optional: if current page exceeds totalPages
                if (page > totalPages) {
                    setPage(1);
                    setInputPage(1);
                } else {
                    setInputPage(page);
                }
            }

        } catch (error) {
            console.error("Failed to fetch trips:", error);
            setTrips([]);
            setTotalPages(0);
            setPage(1);
            setInputPage(0);
        }

        updateLoading(false);
        setIsLoading(false);
    }, [page, searchTerm, selectedVendor, updateLoading]);


    const updateVendorCode = async (tripId, newVendorCode) => {

        if (selectedTrip.vendor_code !== newVendorCode) {
            try {
                const response = await axiosInstance.put(`/api/trip/${selectedTrip.id}/vendor-code`, {
                    vendor_code: newVendorCode
                });

                if (response.data.success) {
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: response.message || "Vendor code updated successfully",
                    });

                    setEditModalOpen(false)
                    fetchTrips();
                }
            } catch (error) {
                console.error("Failed to update vendor code:", error);
            }
        }

        else {
            Swal.fire({
                icon: "info",
                title: "No Changes Made",
                text: "The vendor code is the same as before.",
            });
            setEditModalOpen(false);
        }





    };


    useEffect(() => {
        fetchTrips();
    }, [fetchTrips]);

    useEffect(() => {
        const fetchAllVendors = async () => {
            try {
                const response = await axiosInstance.get("/api/trip/get-trips", {
                    params: { limit: 10000 },
                });

                const allTrips = response.data.data || [];
                const uniqueVendors = [...new Set(allTrips.map(trip => trip.vendor_code).filter(Boolean))];

                setVendorOptions(uniqueVendors);
            } catch (err) {
                console.error("Failed to fetch all vendors:", err);
            }
        };

        fetchAllVendors();
    }, []);


    useEffect(() => {
        if (selectedVendor) {
            setPage(1);
        }
    }, [selectedVendor]);

    // const handleUpdateBay = async () => {
    //     const { number, location_id, shop_id, bay_type_id } = formData;

    //     if (!number || !location_id || !shop_id || !bay_type_id) {
    //         Swal.fire("Error", "Please fill all fields", "error");
    //         return;
    //     }

    //     try {
    //         await axiosInstance.put(`/api/bays/bays/${selectedBay.id}`, {
    //             number: number.trim().toLowerCase().replace(/^bay/, "Bay"),
    //             location_id: Number(location_id),
    //             shop_id: Number(shop_id),
    //             bay_type_id: Number(bay_type_id),
    //         });

    //         Swal.fire({
    //             icon: "success",
    //             title: "Bay updated successfully",
    //             timer: 1500,
    //             showConfirmButton: true,
    //         });

    //         setEditModalOpen(false);
    //         setSelectedBay(null);
    //         setFormData({
    //             number: "",
    //             location_id: "",
    //             bay_type_id: "",
    //             shop_id: "",
    //         });
    //         fetchBayDetails();

    //     } catch (err) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "Error updating bay",
    //             text: err.response?.data?.message || "Something went wrong",
    //         });
    //     }
    // };



    const handleView = (id) => {
        navigate(`/trip/${id}`);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setSelectedFile(file);
        console.log("Selected file:", file);
    };

    const handleUpload = async () => {

        if (!selectedFile) return;

        try {
            const formData = new FormData();
            formData.append("file", selectedFile);

            console.log(formData)


            // Call backend API
            const response = await axiosInstance.post("/api/trip/bulkTrip-upload", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            // Show success message from backend
            Swal.fire("Uploaded!", response.data.message, "success").then(() => {
                // Redirect to index page after closing the alert
                navigate("/trip"); // or your index route
            });

            // Reset file input
            setSelectedFile(null);
            fileInputRef.current.value = null;
        } catch (error) {
            console.error("Upload failed:", error);

            // Show error message
            Swal.fire(
                "Error!",
                error.response?.data?.error || "Failed to upload file",
                "error"
            );
        }
    };

    const handleExport = async () => {
        if (selectedVendor) {
            var vendor = selectedVendor
        }
        else {
            vendor = null
        }


        try {
            const response = await axiosInstance.get(`/api/trip/trip-export/${vendor}`, {
                responseType: "blob", // important to receive file as blob
            });

            // Check if backend sent JSON error instead of Excel
            const contentType = response.headers["content-type"];
            if (contentType && contentType.includes("application/json")) {
                const text = await response.data.text();
                const json = JSON.parse(text);
                Swal.fire("Error!", json.error || "Something went wrong.", "error");
                return;
            }

            // Proceed with Excel download
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Trip_Details.xlsx");

            Swal.fire({
                icon: "success",
                title: "Export Started",
                text: "File Downloading has Started!",
                confirmButtonText: "OK",
            });
        } catch (error) {
            console.error("Export failed:", error);

            let message = "Something went wrong while exporting vehicle data.";

            // Try to extract backend error if available
            if (error.response?.data) {
                try {
                    const text = await error.response.data.text();
                    const json = JSON.parse(text);
                    message = json.error || message;
                } catch { }
            }

            Swal.fire("Error!", message, "error");
        }
    };

    const handleDownloadFormat = () => {
        const dummyData = [
            { sl_no: "1", vendor_code: "A129", bay_type_name: "Others", truckLength: "Small", shop_name: "AS-KB", location_name: "B", bay_name: "AR-B1", bay_time_from: "18:00", bay_time_to: "19:20", trip_name: "A129-K-02-xxxxxxO", stop_order: "1" },

            { sl_no: "2", vendor_code: "A129", bay_type_name: "Others", truckLength: "Small", shop_name: "AS-KB", location_name: "B", bay_name: "AR-B2", bay_time_from: "19:50", bay_time_to: "20:00", trip_name: "A129-K-02-xxxxxxO", stop_order: "2" }
        ];
        const worksheet = XLSX.utils.json_to_sheet(dummyData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "TripFormat");
        XLSX.writeFile(workbook, "Trip_Bulk_Upload_Format.xlsx");
    };


    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const handleFileUploadClick = () => {
        fileInputRef.current.click();
    };

    const handleInputChange = (e) => {
        setInputPage(e.target.value);
    };

    // when user presses Enter or leaves input, update page
    const handleInputSubmit = () => {
        let newPage = Number(inputPage);
        if (trips.length === 0) {
            setInputPage(0); // keep 0 if no data
        } else if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        } else {
            setInputPage(page); // reset if invalid
        }
    };

    return (
        <div className="container-fluid mt-4">


            <div className="row">
                <div className="col-12 px-lg-5 px-3">
                    <div className="d-flex justify-content-end mb-4" style={{ gap: "12px" }}>
                        <NavLink
                            to="/addTrip"
                            className="btn text-white"
                            style={{ backgroundColor: "#0A4595", letterSpacing: "1px" }}
                        >
                            <i className="bi bi-plus-lg me-1"></i>ADD TRIP
                        </NavLink>

                        <button
                            className="btn text-white"
                            style={{ backgroundColor: "rgb(10, 69, 149)" }}
                            onClick={() => setShowBulkModal(true)}
                        >
                            <i className="bi bi-people-fill me-1"></i>Add in Bulk
                        </button>

                        <button className="btn btn-success" onClick={handleExport}>
                            <i className="bi bi-upload me-1"></i>Export
                        </button>
                    </div>
                </div>
            </div>


            <div className="row justify-content-center">
                <div className="col-12 px-lg-5 px-3">
                    <div className="table-responsive" style={{ maxHeight: "600px", overflowY: "auto" }}>
                        <table className="table table-sm">
                            <thead className="table-primary">
                                <tr>
                                    <th className="text-center text-white py-2 px-1" style={{ backgroundColor: "#0A4595", minWidth: "80px" }}>
                                        Sl No.
                                    </th>
                                    <th
                                        className="text-center text-white py-2 px-1"
                                        style={{ backgroundColor: "#0A4595", minWidth: "150px", position: "relative" }}
                                    >
                                        Vendor Code
                                        <FaFilter
                                            className="ms-2 cursor-pointer"
                                            onClick={() => setShowVendorFilter(!showVendorFilter)}
                                        />
                                        <br />

                                        {showVendorFilter && (
                                            <div
                                                className="dropdown-menu show p-2 shadow rounded"
                                                style={{ backgroundColor: "#f8f9fa", zIndex: 20, minWidth: "200px", position: "fixed" }}
                                            >
                                                {/* 🔍 Search inside filter */}
                                                <input
                                                    type="text"
                                                    placeholder="Search vendor..."
                                                    value={vendorSearch || ""}
                                                    onChange={(e) => setVendorSearch(e.target.value)}
                                                    className="form-control mb-2"
                                                    style={{ fontSize: "14px", padding: "5px" }}
                                                />

                                                {/* Vendor List */}
                                                {vendorOptions.length > 0 ? (
                                                    vendorOptions
                                                        .filter((vendor) =>
                                                            vendor.toLowerCase().includes((vendorSearch || "").toLowerCase())
                                                        )
                                                        .map((vendor) => (
                                                            <div
                                                                key={vendor}
                                                                className="dropdown-item rounded px-3 py-2 text-dark fw-semibold hover-bg"
                                                                onClick={() => {
                                                                    setSelectedVendor(vendor);
                                                                    setShowVendorFilter(false);
                                                                    setVendorSearch(""); // reset search after selection
                                                                }}
                                                                style={{
                                                                    cursor: "pointer",
                                                                    transition: "background-color 0.2s",
                                                                }}
                                                                onMouseEnter={(e) =>
                                                                    (e.currentTarget.style.backgroundColor = "#e9ecef")
                                                                }
                                                                onMouseLeave={(e) =>
                                                                    (e.currentTarget.style.backgroundColor = "transparent")
                                                                }
                                                            >
                                                                {vendor}
                                                            </div>
                                                        ))
                                                ) : (
                                                    <div className="text-muted">No Vendors Found</div>
                                                )}
                                            </div>
                                        )}

                                        {/* Selected vendor badge */}
                                        {selectedVendor && (
                                            <div
                                                className="bg-light d-inline-flex align-items-center px-1 py-0 rounded mt-1"
                                                style={{
                                                    fontSize: "12px",
                                                    marginLeft: "5px",
                                                    color: "black",
                                                }}
                                            >
                                                {selectedVendor}
                                                <IoClose
                                                    className="text-danger cursor-pointer ms-1"
                                                    style={{ fontSize: "14px" }}
                                                    onClick={() => setSelectedVendor("")}
                                                />
                                            </div>
                                        )}
                                    </th>

                                    <th className="text-center text-white py-2 px-1" style={{ backgroundColor: "#0A4595", minWidth: "100px" }}>
                                        Trip
                                    </th>
                                    <th className="text-center text-white py-2 px-1" style={{ backgroundColor: "#0A4595", minWidth: "120px" }}>
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {trips.length > 0 ? (
                                    trips.map((trip, index) => (
                                        <tr key={trip.id || index}>
                                            <td className="text-center p-2">{(page - 1) * 10 + index + 1}</td>
                                            <td className="text-center p-2">{trip.vendor_code}</td>
                                            <td className="text-center p-2">{trip.route_name}</td>
                                            <td className="text-center p-2">
                                                <img
                                                    src={View}
                                                    alt="View"
                                                    className="action-icon mx-2"
                                                    onClick={() => handleView(trip.id)}
                                                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                                                    title="View"
                                                />
                                                <img
                                                    src={Edit}
                                                    alt="Edit"
                                                    className="action-icon mx-2"
                                                    style={{ width: "18px", height: "18px" }}
                                                    title="Edit"
                                                    onClick={() => {
                                                        setSelectedTrip(trip);
                                                        setFormData({
                                                            vendor_code: trip.vendor_code || "",
                                                            route_name: trip.route_name || "",
                                                        });
                                                        setEditModalOpen(true);
                                                    }}

                                                />
                                                {editModalOpen && (
                                                    <div
                                                        onClick={() => setEditModalOpen(false)}
                                                        style={{
                                                            position: "fixed",
                                                            inset: 0,
                                                            background: "rgba(0, 0, 0, 0.1)",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            zIndex: 9999,
                                                            padding: "20px",
                                                        }}
                                                    >
                                                        <div
                                                            onClick={(e) => e.stopPropagation()}
                                                            style={{
                                                                background: "#fff",
                                                                borderRadius: "16px",
                                                                width: "100%",
                                                                maxWidth: "600px",
                                                                padding: "24px",
                                                                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.0)",
                                                                overflowY: "auto",
                                                                maxHeight: "90vh",
                                                                fontFamily: "'Inter', sans-serif",
                                                            }}
                                                        >
                                                            {/* Header */}
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    borderBottom: "1px solid #eee",
                                                                    paddingBottom: "16px",
                                                                    marginBottom: "24px",
                                                                }}
                                                            >
                                                                <h2 style={{ margin: 0, fontSize: "22px", fontWeight: 600, color: "#333" }}>
                                                                    Edit Trip
                                                                </h2>
                                                                <button
                                                                    onClick={() => setEditModalOpen(false)}
                                                                    style={{
                                                                        background: "none",
                                                                        border: "none",
                                                                        fontSize: "22px",
                                                                        fontWeight: "bold",
                                                                        cursor: "pointer",
                                                                        color: "#999",
                                                                    }}
                                                                >
                                                                    ✕
                                                                </button>
                                                            </div>

                                                            {/* Form Inputs in One Row */}
                                                            <form
                                                                onSubmit={(e) => {
                                                                    e.preventDefault();
                                                                    // handleUpdateBay();
                                                                }}
                                                                style={{
                                                                    display: "flex",
                                                                    gap: "20px",
                                                                    flexWrap: "wrap",
                                                                    marginBottom: "20px",
                                                                }}
                                                            >
                                                                {/* Bay Number */}
                                                                <div style={{ flex: 1, minWidth: "200px" }}>
                                                                    <label
                                                                        style={{
                                                                            fontSize: "13px",
                                                                            fontWeight: 600,
                                                                            marginBottom: "6px",
                                                                            display: "block",
                                                                            color: "#333",
                                                                            fontFamily: "Arial, sans-serif",
                                                                        }}
                                                                    >
                                                                        Vendor Code
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={formData.vendor_code}
                                                                        onChange={(e) => setFormData({ ...formData, vendor_code: e.target.value })}
                                                                        style={{
                                                                            padding: "10px",
                                                                            borderRadius: "8px",
                                                                            border: "1px solid #ccc",
                                                                            fontSize: "13px",
                                                                            fontFamily: "Arial, sans-serif",
                                                                            width: "100%",
                                                                        }}
                                                                    />
                                                                </div>

                                                                {/* Location */}
                                                                <div style={{ flex: 1, minWidth: "200px" }}>
                                                                    <label
                                                                        style={{
                                                                            fontSize: "13px",
                                                                            fontWeight: 600,
                                                                            marginBottom: "6px",
                                                                            display: "block",
                                                                            color: "#333",
                                                                            fontFamily: "Arial, sans-serif",
                                                                        }}
                                                                    >
                                                                        Trip
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={formData.route_name}
                                                                        readOnly
                                                                        style={{
                                                                            padding: "10px",
                                                                            borderRadius: "8px",
                                                                            border: "1px solid #ccc",
                                                                            fontSize: "13px",
                                                                            fontFamily: "Arial, sans-serif",
                                                                            width: "100%",
                                                                            backgroundColor: "#f5f5f5",
                                                                        }}
                                                                    />

                                                                </div>


                                                            </form>


                                                            {/* Buttons */}
                                                            <div style={{ textAlign: "right" }}>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setEditModalOpen(false)}
                                                                    style={{
                                                                        padding: "10px 16px",
                                                                        marginRight: "10px",
                                                                        backgroundColor: "#e0e0e0",
                                                                        color: "#333",
                                                                        border: "none",
                                                                        borderRadius: "6px",
                                                                        fontSize: "13px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => updateVendorCode(trip.id, formData.vendor_code)}
                                                                    style={{
                                                                        padding: "10px 20px",
                                                                        backgroundColor: 'rgb(10, 69, 149)',
                                                                        color: "#fff",
                                                                        border: "none",
                                                                        borderRadius: "6px",
                                                                        fontSize: "13px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    Update
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {localStorage.getItem("userRole") === "admin" && (
                                                    <>
                                                        <img
                                                            src={Edit}
                                                            alt="Edit"
                                                            className="action-icon mx-2"
                                                            style={{ width: "18px", height: "18px", cursor: "pointer" }}
                                                            title="Edit"
                                                        />
                                                        <img
                                                            src={Delete}
                                                            alt="Delete"
                                                            className="action-icon mx-2"
                                                            style={{ width: "18px", height: "18px", cursor: "pointer" }}
                                                            title="Delete"
                                                        />
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center p-3">
                                            {!isLoading && <p>No trips available</p>}
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>

            <div className="row justify-content-center mt-4 mb-5">
                <div className="col-auto">
                    <button
                        className="btn btn-sm mx-2"
                        onClick={() => handlePageChange(page - 1)}
                        style={{ backgroundColor: "rgb(10, 69, 149)", color: "white" }}
                        disabled={page === 1}
                    >
                        Previous
                    </button>
                </div>

                <div className="col-auto d-flex align-items-center">
                    <span className="mx-2">Page</span>
                    <input
                        type="number"
                        value={trips.length === 0 ? 0 : inputPage}
                        onChange={handleInputChange}
                        onBlur={handleInputSubmit}
                        onKeyDown={(e) => e.key === "Enter" && handleInputSubmit()}
                        style={{ width: "60px", textAlign: "center" }}
                        min={trips.length === 0 ? 0 : 1}
                        max={totalPages}
                        disabled={trips.length === 0}
                    />
                    <span className="mx-2">of {totalPages}</span>
                </div>



                <div className="col-auto">
                    <button
                        className="btn btn-sm mx-2"
                        onClick={() => handlePageChange(page + 1)}
                        style={{ backgroundColor: "rgb(10, 69, 149)", color: "white" }}
                        disabled={page === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>

            {showBulkModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                    <div
                        className="d-flex flex-column align-items-center justify-content-center p-4"
                        style={{
                            borderRadius: "10px",
                            maxWidth: "600px",
                            margin: "200px auto 0 auto",
                            textAlign: "center",
                            backgroundColor: "#fafafa",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                            position: "relative",
                        }}
                    >
                        {/* ✅ Top right Download Format button */}
                        <button
                            className="btn btn-outline-primary position-absolute"
                            style={{ top: "15px", right: "20px", borderRadius: "20px", fontWeight: "500" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadFormat();
                            }}
                        >
                            <i className="bi bi-download me-2"></i> Download Format
                        </button>

                        <p className="h5 mb-2 mt-4 fw-bold" style={{ color: "#0A4595", fontWeight: "600" }}>
                            Select File Here
                        </p>

                        <p className="mb-4" style={{ color: "#6c757d", fontSize: "0.9rem" }}>
                            If you want to see which data is required, please download the format above.
                        </p>


                        {/* Hidden file input */}
                        <input
                            type="file"
                            accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                        {/* Custom file box */}
                        <div className="d-flex align-items-center" style={{ width: "50%", minWidth: "220px", maxWidth: "250px" }}>
                            {/* File box */}
                            <div
                                className="flex-grow-1 p-1"
                                style={{ backgroundColor: "#d8d8d8ff", cursor: "pointer", border: "1px solid #9e9e9eff" }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleFileUploadClick();

                                }}
                            >
                                <span className="text-truncate">
                                    Choose File
                                </span>
                            </div>

                            {/* Span outside box on the right */}
                            <span
                                className="text-muted ms-2"
                                style={{ whiteSpace: "nowrap", fontSize: "0.9rem", alignSelf: "center" }}
                            >
                                {selectedFile ? selectedFile.name : "No file choosen"}
                            </span>
                        </div>

                        {/* File supported text with red star */}
                        <p
                            className="mt-2"
                            style={{ color: "#6c757d", fontSize: "0.9rem", fontStyle: "italic" }}
                        >
                            <span style={{ color: "red" }}>*</span> Files Supported: CSV, XLS, XLSX
                        </p>

                        {/* Upload button */}
                        <div className="d-flex justify-content-center mt-3 gap-3">
                            <button
                                className="btn"
                                style={{
                                    backgroundColor: "rgb(10, 69, 149)",
                                    color: "white",
                                    fontWeight: "500",
                                    borderRadius: "6px",
                                    width: "140px",
                                }}
                                onClick={handleUpload}
                                disabled={!selectedFile} // disabled until file is selected
                            >
                                Upload
                            </button>

                            <button
                                className="btn btn-secondary"
                                style={{
                                    fontWeight: "500",
                                    borderRadius: "6px",
                                    width: "140px",
                                }}
                                onClick={() => setShowBulkModal(false)} // close modal or perform cancel action
                            >
                                Cancel
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {(showBulkModal) && (
                <div
                    className="modal-backdrop fade show"
                    onClick={() => {

                        setShowBulkModal(false);
                    }}
                ></div>
            )}

        </div>
    );
};

export default Trip;